import { Button } from 'common/interaction';
import styled from 'styled-components';
import { media } from 'styles/utils';

export const ExtendedButton = styled(Button)`
  justify-content: center;
  width: 100%;
  flex: 1;
  white-space: nowrap;

  ${media.desktop`
    width: auto;
  `}
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
  max-width: 480px;
  margin-top: 36px;
`;
